import { render, staticRenderFns } from "./OrderListCancelNew.vue?vue&type=template&id=1ce5a1f3&scoped=true"
import script from "./OrderListCancelNew.vue?vue&type=script&lang=js"
export * from "./OrderListCancelNew.vue?vue&type=script&lang=js"
import style0 from "./OrderListCancelNew.vue?vue&type=style&index=0&id=1ce5a1f3&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce5a1f3",
  null
  
)

export default component.exports